import { useNavigate } from "react-router-dom";
import { DataTable } from "../../../components/data-table";
import { AddCoworkerCompany } from "../components/add_company";
import { Tooltip } from "flowbite-react";
import { ToggleCoworkerCompany as RemoveCoworkerCompany } from "../components/remove_company_action";
import { IconButton } from "../../../components/buttons";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import {
  GETCOWORKERCOMPANIES_REQ,
} from "../../../actions";
import { COWORKERCOMPANY_RESPONSE } from "../../../constants/action_types";

function Companies({ coworker_uid, coworkerDetails }) {
  const navigate = useNavigate();
  const urlParams = useRef({});
  const dispatch = useDispatch();

  const companyDetails = useSelector(
    (state) => state.coworker?.details?.coworker_companies
  );

  const coworkersUpdated = useSelector(
    (state) => state?.coworker?.update_response
  );

  useEffect(() => {
    if (coworkersUpdated?.type === COWORKERCOMPANY_RESPONSE) {
      handleFetch();
    }
  }, [coworkersUpdated]);

  const handleFetch = async (params) => {
    if (params) {
      urlParams.current.page = params.page;
      urlParams.current.count = params.pageLimit;
      urlParams.current.sort_by = params.sortBy;
      urlParams.current.sort = params.sortDir;
      urlParams.current["filter.keyword"] = params.keyword || "";
    }
    dispatch(
      GETCOWORKERCOMPANIES_REQ({ params: urlParams.current, coworker_uid })
    );
  };

  const columns = [
    {
      name: "Company Name",
      key: "company_name",
      onCellClick: (payload) => {
        navigate(`/customers/${payload.row.company_uid}/details`);
      },
      width: 48,
    },
    {
      name: "Country",
      key: "company_country",
    },
    { name: "Total User ", key: "total_users" },
    {
      name: "Phone Number",
      key: "company_phone",
    },
    {
      name: "Status",
      key: "is_active",
      disableSort: true,
      formatText: (isActive) => (isActive ? "Active" : "Inactive"),
      processClassName: (isActive) =>
        isActive ? "text-green-500 font-medium" : "text-red-500 font-medium",
    },
    {
      name: "Action",
      type: "actions",
      actions: [
        {
          element:
            coworkerDetails?.role === "CS" ? (
              <RemoveCoworkerCompany coworkerDetails={coworkerDetails} />
            ) : (
              <></>
            ),
        },
        {
          icon: (
            <Tooltip content="View Company" placement="bottom">
              <IconButton>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4 cursor-pointer z-10"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </IconButton>
            </Tooltip>
          ),
          action: (data) => {
            navigate(`/customers/${data.company_uid}/details`);
          },
        },
      ],
    },
  ];

  return (
    <>
      <div class="h-full mt-3">
        <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
          <div class="p-2 h-full">
            <div class="flow-root h-full">
              <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 h-full">
                <div class="h-full inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                  <DataTable
                    remote={true}
                    name="Companies"
                    columns={columns}
                    data={companyDetails?.data}
                    totalCount={companyDetails?.totalCount}
                    handleFetch={handleFetch}
                    toolbar={{
                      search: { enable: true, searchBy: "company_name" },

                      customAction: (
                        <AddCoworkerCompany
                          companyDetails={companyDetails}
                          coworkerDetails={coworkerDetails}
                        />
                      ),
                    }}
                    footer={{ paginator: { enable: true, limits: [10] } }}
                    // paginator={{ enable: true, limits: [10] }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Companies;
